module.exports = __webpack_public_path__ + "img/vehicle-risk-black.9a054851.png";